export const LOYALTY_STYLE_PROPERTIES = [
    'BackgroundColor',
    'TextColor',
    'Font',
    'ProgressBarColor',
    'ArrowColor',
    'ShowUnderline',
    'ShowBoxShadow',
    'FontSize',
    'ArrowSize',
    'ProgressBarBackgroundColor',
    'ProgressBarHeight',
    'ProgressBarBorderRadius',
    'LOLContentPaddingLeft',
    'LOLArrowTop',
    'LOLArrowContainerRight'
];